import React from 'react';

import AttentionMessage from './AttentionMessage';
import { WarningMessageProps } from './types';

const WarningMessage = ({ ...rest }: WarningMessageProps) => {
    return <AttentionMessage type="warning" {...rest} />;
};

export default WarningMessage;
